import React, { useMemo } from 'react';
import styles from './NavLayout.module.scss';
import { wellbeingFoundationOptions } from '@src/constants';
import ProgramDescription from '@src/components/program-description/ProgramDescription';
import { SllProgram } from '@src/api/graphql-codegen';


type Props = {
  program: SllProgram;
  styleMode: string;
  handleSelectStyleMode?: (styleMode: any) => void;
  isAUuser?: boolean;
};

function NavLayout(props: Props) {
  const { styleMode, program, isAUuser, handleSelectStyleMode } = props;

  const _filtered = useMemo(() => {
    return Object.keys(wellbeingFoundationOptions)
  }, []);

  return (
    <>
      <div id={"navMenuBar"} className={styles.navView}>
        <div className={styles.title} style={{display: 'flex'}}>{isAUuser ? "Wellbeing Foundations" : "Well-Being Foundations"}</div>
        <div className={styles.tabLayout}>
        {_filtered.map((item, index) => {
          return (
            <div key={index} className={styles.itemWrapper} onClick={() => handleSelectStyleMode?.(item)} >
              <div className={[styles.listItem, (styleMode === item) ? styles.selItem : ''].join(' ')}>
                <div className={[styles.listTitle, styleMode === item ? styles.selItemTitle : ''].join(' ')}>
                  {wellbeingFoundationOptions[item]}
                </div>
              </div>
            </div>
          )
        })}
        </div>
      </div>
      <ProgramDescription program={program} programName={styleMode} isAUuser={isAUuser} />
    </>
  );
}

export default NavLayout;
